if (!window.isQuickAddModal) {
  const isHoverCapable =
    window.matchMedia("(hover: hover) and (pointer: fine)").matches &&
    !(navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
  const desktopGalleryMediaQuery = window.matchMedia("(min-width: 950px)");
  let slideIndex = 1;
  let galleryContext = null;
  let galleryObserver = null;
  let galleryActiveIndex = 1;
  let galleryResizeFrame = 0;
  let galleryFallbackScrollFrame = 0;
  let desktopThumbLockIndex = null;
  let desktopThumbLockUntil = 0;

  function pauseGalleryMedia() {
    var mediaElements = document.querySelectorAll(
      ".product-video-not-autoplay video"
    );
    mediaElements.forEach(function (media) {
      media.pause();
    });
    document
      .querySelectorAll(".product-media-external-media")
      .forEach((videoContainer) => {
        const iframe = videoContainer.querySelector("iframe");
        if (iframe && iframe.contentWindow) {
          const message = JSON.stringify({
            event: "command",
            func: "pauseVideo",
            args: "",
          });
          iframe.contentWindow.postMessage(message, "*");
        }
      });
    document
      .querySelectorAll(".external-media-iframe-container")
      .forEach((videoContainer) => {
        const iframe = videoContainer.querySelector("iframe");
        if (iframe && iframe.contentWindow) {
          const message = JSON.stringify({
            event: "command",
            func: "pauseVideo",
            args: "",
          });
          iframe.contentWindow.postMessage(message, "*");
        }
      });
    document
      .querySelectorAll(".external-media-vimeo-iframe-container")
      .forEach((videoContainer) => {
        const iframe = videoContainer.querySelector("iframe");
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage('{"method":"pause"}', "*");
        }
      });
  }

  function buildGalleryContext(sourceElement) {
    const root =
      sourceElement instanceof Element
        ? sourceElement.closest(".product-media-component")
        : document.querySelector(".product-media-component");

    if (!root) {
      return null;
    }

    const slidesContainer = root.querySelector("#SlidesCon");

    return {
      root,
      slidesContainer,
      slides: slidesContainer
        ? Array.from(slidesContainer.querySelectorAll(".product-media-image"))
        : [],
      thumbnails: Array.from(root.querySelectorAll(".gallery-slider--thumbnail")),
      thumbnailRail: root.querySelector(".gallery-slider-thumbnails"),
      thumbnailInner:
        root.querySelector(".gst-inner--floating-thumbs") ||
        root.querySelector(".gst-inner") ||
        root.querySelector(".gst-scroller"),
      leftArrow: document.querySelector(".gallery-slider-arrows .slider-arrow-left"),
      rightArrow: document.querySelector(
        ".gallery-slider-arrows .slider-arrow-right"
      ),
      isFloatingThumbs: root.classList.contains(
        "product-media-component--floating-thumbs"
      ),
    };
  }

  function refreshGalleryContext(sourceElement) {
    galleryContext = buildGalleryContext(sourceElement);
    return galleryContext;
  }

  function getGalleryContext(sourceElement) {
    return galleryContext || refreshGalleryContext(sourceElement);
  }

  function isDesktopFloatingThumbs(context = galleryContext) {
    return Boolean(context?.isFloatingThumbs && desktopGalleryMediaQuery.matches);
  }

  function normalizeGalleryIndex(index, context = galleryContext) {
    const totalSlides = context?.slides?.length || 0;

    if (!totalSlides) {
      return 1;
    }

    if (index > totalSlides) {
      return 1;
    }

    if (index < 1) {
      return totalSlides;
    }

    return index;
  }

  function getGallerySlide(index, context = galleryContext) {
    const normalizedIndex = normalizeGalleryIndex(index, context);

    return context?.slides.find(
      (slide) => Number(slide.getAttribute("data-slide-index")) === normalizedIndex
    );
  }

  function getGalleryThumbnail(index, context = galleryContext) {
    const normalizedIndex = normalizeGalleryIndex(index, context);

    return context?.thumbnails.find(
      (thumb) => Number(thumb.getAttribute("data-slide-index")) === normalizedIndex
    );
  }

  function getDesktopHeaderOffset() {
    const rootStyles = window.getComputedStyle(document.documentElement);
    const headerHeight =
      parseFloat(rootStyles.getPropertyValue("--site-header-height-desktop")) || 0;
    const hasAnnouncement = Boolean(
      document.querySelector(".full-width-announcement-bar")
    );
    const hasSemiTransparentHeader = Boolean(
      document.querySelector(".hbi-semi-transparent")
    );
    const hasFullHeader = Boolean(document.querySelector(".header-bar--full"));

    if (hasSemiTransparentHeader) {
      return hasAnnouncement ? 35 : 0;
    }

    if (hasFullHeader) {
      return headerHeight + (hasAnnouncement ? 35 : 0);
    }

    return hasAnnouncement ? 35 : 0;
  }

  function getDesktopThumbTop() {
    return getDesktopHeaderOffset();
  }

  function getDesktopThumbLine(context = galleryContext) {
    const topValue = context?.thumbnailRail
      ? parseFloat(window.getComputedStyle(context.thumbnailRail).top)
      : NaN;

    return Number.isFinite(topValue) ? topValue + 22 : getDesktopThumbTop() + 22;
  }

  function getGalleryTimestamp() {
    return window.performance?.now ? window.performance.now() : Date.now();
  }

  function clearDesktopThumbLock() {
    desktopThumbLockIndex = null;
    desktopThumbLockUntil = 0;
  }

  function lockDesktopThumb(index, context = galleryContext) {
    if (!isDesktopFloatingThumbs(context)) {
      clearDesktopThumbLock();
      return;
    }

    desktopThumbLockIndex = normalizeGalleryIndex(index, context);
    desktopThumbLockUntil = getGalleryTimestamp() + 1800;
  }

  function hasDesktopThumbLock(context = galleryContext) {
    if (!isDesktopFloatingThumbs(context) || desktopThumbLockIndex === null) {
      return false;
    }

    if (getGalleryTimestamp() > desktopThumbLockUntil) {
      clearDesktopThumbLock();
      return false;
    }

    return true;
  }

  function getThumbnailScrollContainer(context = galleryContext) {
    if (!context) {
      return null;
    }

    if (isDesktopFloatingThumbs(context)) {
      return context.thumbnailInner || context.thumbnailRail;
    }

    return context.thumbnailRail;
  }

  function syncActiveThumbnailScroller(activeThumbnail, context = galleryContext) {
    const scroller = getThumbnailScrollContainer(context);

    if (!scroller || !activeThumbnail) {
      return;
    }

    const buffer = isDesktopFloatingThumbs(context) ? 8 : 12;
    const scrollerRect = scroller.getBoundingClientRect();
    const thumbRect = activeThumbnail.getBoundingClientRect();

    if (isDesktopFloatingThumbs(context)) {
      if (thumbRect.top < scrollerRect.top + buffer) {
        scroller.scrollBy({
          top: thumbRect.top - scrollerRect.top - buffer,
          behavior: "smooth",
        });
        return;
      }

      if (thumbRect.bottom > scrollerRect.bottom - buffer) {
        scroller.scrollBy({
          top: thumbRect.bottom - scrollerRect.bottom + buffer,
          behavior: "smooth",
        });
      }
      return;
    }

    if (thumbRect.left < scrollerRect.left + buffer) {
      scroller.scrollBy({
        left: thumbRect.left - scrollerRect.left - buffer,
        behavior: "smooth",
      });
      return;
    }

    if (thumbRect.right > scrollerRect.right - buffer) {
      scroller.scrollBy({
        left: thumbRect.right - scrollerRect.right + buffer,
        behavior: "smooth",
      });
    }
  }

  function setActiveGalleryThumbnail(
    index,
    { pauseMediaOnChange = true, syncRail = true } = {}
  ) {
    const context = getGalleryContext();

    if (!context?.thumbnails.length) {
      return;
    }

    const normalizedIndex = normalizeGalleryIndex(index, context);
    let activeThumbnail = null;

    if (pauseMediaOnChange && galleryActiveIndex !== normalizedIndex) {
      pauseGalleryMedia();
    }

    galleryActiveIndex = normalizedIndex;

    context.thumbnails.forEach((thumb) => {
      const isActive =
        Number(thumb.getAttribute("data-slide-index")) === normalizedIndex;
      thumb.classList.toggle("active", isActive);

      if (isActive) {
        activeThumbnail = thumb;
      }
    });

    if (activeThumbnail && syncRail) {
      syncActiveThumbnailScroller(activeThumbnail, context);
    }
  }

  function getIndexFromSliderScroll(context = galleryContext) {
    if (!context?.slidesContainer) {
      return 1;
    }

    const slideWidth = context.slidesContainer.offsetWidth || 1;
    const scrollPosition = context.slidesContainer.scrollLeft;

    return normalizeGalleryIndex(
      Math.round(scrollPosition / slideWidth) + 1,
      context
    );
  }

  function getDesktopScrollIndex(context = galleryContext) {
    if (!context?.slides.length) {
      return 1;
    }

    const viewportOffset = getDesktopThumbLine(context);
    let activeIndex = Number(
      context.slides[0].getAttribute("data-slide-index")
    ) || 1;

    context.slides.forEach((slide) => {
      const slideIndex = Number(slide.getAttribute("data-slide-index"));

      if (!slideIndex) {
        return;
      }

      const rect = slide.getBoundingClientRect();

      if (rect.top <= viewportOffset + 1) {
        activeIndex = slideIndex;
      }
    });

    return activeIndex;
  }

  function syncDesktopThumbState(options = {}) {
    const context = getGalleryContext();

    if (!isDesktopFloatingThumbs(context)) {
      return;
    }

    const currentIndex = getDesktopScrollIndex(context);

    if (hasDesktopThumbLock(context)) {
      if (currentIndex === desktopThumbLockIndex) {
        clearDesktopThumbLock();
        setActiveGalleryThumbnail(currentIndex, options);
        return;
      }

      setActiveGalleryThumbnail(desktopThumbLockIndex, options);
      return;
    }

    setActiveGalleryThumbnail(currentIndex, options);
  }

  function initDesktopThumbObserver() {
    if (galleryObserver) {
      galleryObserver.disconnect();
      galleryObserver = null;
    }

    const context = refreshGalleryContext();

    if (
      !isDesktopFloatingThumbs(context) ||
      !context?.slides.length ||
      !("IntersectionObserver" in window)
    ) {
      return;
    }

    galleryObserver = new IntersectionObserver(
      () => {
        syncDesktopThumbState();
      },
      {
        root: null,
        rootMargin: `-${Math.round(
          getDesktopThumbLine(context)
        )}px 0px -40% 0px`,
        threshold: [0, 0.15, 0.35, 0.55, 0.75],
      }
    );

    context.slides.forEach((slide) => {
      galleryObserver.observe(slide);
    });
  }

  function scrollDesktopToSlide(index, context = galleryContext) {
    const targetSlide = getGallerySlide(index, context);

    if (!targetSlide) {
      return;
    }

    window.scrollTo({
      top:
        targetSlide.getBoundingClientRect().top +
        window.scrollY -
        getDesktopThumbTop(context),
      behavior: "smooth",
    });
  }

  function scrollSliderToIndex(index, context = galleryContext) {
    if (!context?.slidesContainer) {
      return;
    }

    const slideWidth = context.slidesContainer.offsetWidth;

    context.slidesContainer.scrollTo({
      left: (normalizeGalleryIndex(index, context) - 1) * slideWidth,
      behavior: "smooth",
    });
  }

  function changeSlide(thumbnail, index) {
    const context = refreshGalleryContext(thumbnail);

    if (!context?.slidesContainer) {
      return;
    }

    const normalizedIndex = normalizeGalleryIndex(index, context);

    if (isDesktopFloatingThumbs(context)) {
      lockDesktopThumb(normalizedIndex, context);
    } else {
      clearDesktopThumbLock();
    }

    setActiveGalleryThumbnail(normalizedIndex);

    if (isDesktopFloatingThumbs(context)) {
      scrollDesktopToSlide(normalizedIndex, context);
      return;
    }

    scrollSliderToIndex(normalizedIndex, context);
    updateArrowStates();
  }

  function handleScroll() {
    const context = getGalleryContext();

    if (!context?.slidesContainer || isDesktopFloatingThumbs(context)) {
      return;
    }

    setActiveGalleryThumbnail(getIndexFromSliderScroll(context));
    updateArrowStates();
  }

  function updateArrowStates() {
    const context = getGalleryContext();

    if (
      !context?.leftArrow ||
      !context?.rightArrow ||
      !context?.slidesContainer ||
      isDesktopFloatingThumbs(context)
    ) {
      return;
    }

    if (context.slidesContainer.scrollLeft <= 0) {
      context.leftArrow.classList.add("deactive");
    } else {
      context.leftArrow.classList.remove("deactive");
    }

    if (
      context.slidesContainer.scrollLeft + context.slidesContainer.clientWidth >=
      context.slidesContainer.scrollWidth
    ) {
      context.rightArrow.classList.add("deactive");
    } else {
      context.rightArrow.classList.remove("deactive");
    }
  }

  function sliderArrows() {
    const context = getGalleryContext();

    if (!context?.leftArrow || !context?.rightArrow || !context?.slidesContainer) {
      return;
    }

    if (context.leftArrow.dataset.galleryBound === "true") {
      updateArrowStates();
      return;
    }

    context.leftArrow.dataset.galleryBound = "true";
    context.rightArrow.dataset.galleryBound = "true";

    context.leftArrow.addEventListener("click", () => {
      if (isDesktopFloatingThumbs()) {
        return;
      }

      context.slidesContainer.scrollBy({
        left: -Math.round(context.slidesContainer.offsetWidth),
        behavior: "smooth",
      });
      pauseGalleryMedia();
      window.setTimeout(updateArrowStates, 350);
    });

    context.rightArrow.addEventListener("click", () => {
      if (isDesktopFloatingThumbs()) {
        return;
      }

      context.slidesContainer.scrollBy({
        left: Math.round(context.slidesContainer.offsetWidth),
        behavior: "smooth",
      });
      pauseGalleryMedia();
      window.setTimeout(updateArrowStates, 350);
    });

    updateArrowStates();
  }

  function scheduleGalleryRefresh() {
    window.cancelAnimationFrame(galleryResizeFrame);
    galleryResizeFrame = window.requestAnimationFrame(() => {
      refreshGalleryContext();
      initDesktopThumbObserver();

      if (isDesktopFloatingThumbs()) {
        syncDesktopThumbState({ pauseMediaOnChange: false });
      } else {
        clearDesktopThumbLock();
        setActiveGalleryThumbnail(getIndexFromSliderScroll(), {
          pauseMediaOnChange: false,
          syncRail: false,
        });
        updateArrowStates();
      }
    });
  }

  function handleDesktopThumbFallbackScroll() {
    if ("IntersectionObserver" in window || !isDesktopFloatingThumbs()) {
      return;
    }

    window.cancelAnimationFrame(galleryFallbackScrollFrame);
    galleryFallbackScrollFrame = window.requestAnimationFrame(() => {
      syncDesktopThumbState();
    });
  }

  function initProductMediaGallery() {
    const context = refreshGalleryContext();

    if (!context?.slidesContainer) {
      return;
    }

    if (context.slidesContainer.dataset.galleryScrollBound !== "true") {
      context.slidesContainer.addEventListener("scroll", handleScroll, {
        passive: true,
      });
      context.slidesContainer.dataset.galleryScrollBound = "true";
    }

    sliderArrows();
    initDesktopThumbObserver();

    if (isDesktopFloatingThumbs(context)) {
      syncDesktopThumbState({ pauseMediaOnChange: false });
    } else {
      clearDesktopThumbLock();
      setActiveGalleryThumbnail(getIndexFromSliderScroll(context), {
        pauseMediaOnChange: false,
        syncRail: false,
      });
      updateArrowStates();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProductMediaGallery);
  } else {
    initProductMediaGallery();
  }
  window.addEventListener("resize", scheduleGalleryRefresh, { passive: true });
  window.addEventListener("scroll", handleDesktopThumbFallbackScroll, {
    passive: true,
  });

  if (typeof desktopGalleryMediaQuery.addEventListener === "function") {
    desktopGalleryMediaQuery.addEventListener("change", scheduleGalleryRefresh);
  } else if (typeof desktopGalleryMediaQuery.addListener === "function") {
    desktopGalleryMediaQuery.addListener(scheduleGalleryRefresh);
  }

  // Modal Opening and Closing
  function openModal() {
    document.getElementById("galModal").classList.add("open");
    document.body.classList.add("body-lock-scroll");
    setModalZoomToggle();
  }

  function closeModal() {
    document.getElementById("galModal").classList.remove("open");
    document.body.classList.remove("body-lock-scroll");

    // Add a short delay before resetting the zoom level
    setTimeout(() => {
      removeZoomLevel();
    }, 500);
  }

  function currentSlide(n) {
    showSlides(n);
    setActiveThumbnail(slideIndex);
    syncGalleryThumbnail(slideIndex);
  }

  function showSlides(n) {
    var slides = document.getElementsByClassName("galSlides");

    if (!slides.length) {
      return;
    }

    if (n > slides.length) {
      slideIndex = 1;
    } else if (n < 1) {
      slideIndex = slides.length;
    } else {
      slideIndex = n;
    }

    for (var i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }

    slides[slideIndex - 1].style.display = "block";
  }

  function plusSlides(n) {
    showSlides(slideIndex + n);
    setActiveThumbnail(slideIndex);
    syncGalleryThumbnail(slideIndex);
    pauseGalleryMedia();
    resetZoomLevel();
    setImageToTop();
  }

  function setActiveThumbnail(slideIndex) {
    var thumbnails = document.getElementsByClassName("lightbox-thumbnail");

    for (var i = 0; i < thumbnails.length; i++) {
      thumbnails[i].classList.remove("lightbox-thumbnail-active");

      // Check if the thumbnail's data-slide-index matches the provided slideIndex
      if (thumbnails[i].getAttribute("data-slide-index") == slideIndex) {
        thumbnails[i].classList.add("lightbox-thumbnail-active");
      }
    }
  }

  function syncGalleryThumbnail(activeIndex) {
    setActiveGalleryThumbnail(activeIndex, {
      pauseMediaOnChange: false,
    });
  }

  // Thumbnails scroller
  function thumbnailsScroll() {
    const scroller = document.querySelector(".gst-scroller");
    const thumbnails = document.querySelectorAll(".gallery-slider--thumbnail");

    if (!scroller || thumbnails.length === 0) return;

    const isHorizontal = scroller.classList.contains("pos-bottom");

    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener("click", () => {
        const next = thumbnails[index + 1];
        const prev = thumbnails[index - 1];

        if (isHorizontal) {
          const buffer = 10; // match CSS gap
          const thumbWidth = thumb.offsetWidth;
          const scrollerLeft = scroller.scrollLeft;
          const scrollerRight = scrollerLeft + scroller.clientWidth;

          if (next) {
            const nextLeft = next.offsetLeft;
            if (nextLeft >= scrollerRight - buffer) {
              scroller.scrollBy({
                left: thumbWidth + buffer,
                behavior: "smooth",
              });
              return;
            }
          }

          if (prev) {
            const prevLeft = prev.offsetLeft;
            if (prevLeft < scrollerLeft + buffer) {
              scroller.scrollBy({
                left: -(thumbWidth + buffer),
                behavior: "smooth",
              });
            }
          }
        } else {
          const thumbHeight = thumb.offsetHeight;
          const buffer = 8; // match CSS gap
          const scrollerTop = scroller.scrollTop;
          const scrollerBottom = scrollerTop + scroller.clientHeight;

          if (next) {
            const nextTop = next.offsetTop;
            if (nextTop >= scrollerBottom - buffer) {
              scroller.scrollBy({
                top: thumbHeight + buffer,
                behavior: "smooth",
              });
              return;
            }
          }

          if (prev) {
            const prevTop = prev.offsetTop;
            if (prevTop < scrollerTop + buffer) {
              scroller.scrollBy({
                top: -(thumbHeight + buffer),
                behavior: "smooth",
              });
            }
          }
        }
      });
    });
  }

  // Initialize the function
  thumbnailsScroll();

  // Thumbnails scroller within modal
  function modalThumbnailsScroll() {
    const scroller = document.querySelector(".modal-thumbs-track-scroller");
    const parentOfScroller = document.querySelector(
      ".modal-thumbs-track-outer"
    );
    const thumbnails = document.querySelectorAll(".lightbox-thumbnail");
    if (!scroller || thumbnails.length === 0) return;
    const isHorizontal = parentOfScroller.classList.contains(
      "zoom-thumbnails-position-desktop-bottom"
    );

    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener("click", () => {
        const next = thumbnails[index + 1];
        const prev = thumbnails[index - 1];

        if (isHorizontal) {
          const buffer = 6; // match CSS gap
          const thumbWidth = thumb.offsetWidth;
          const scrollerLeft = scroller.scrollLeft;
          const scrollerRight = scrollerLeft + scroller.clientWidth;

          if (next) {
            const nextLeft = next.offsetLeft;
            if (nextLeft >= scrollerRight - buffer) {
              scroller.scrollBy({
                left: thumbWidth + buffer,
                behavior: "smooth",
              });
              return;
            }
          }

          if (prev) {
            const prevLeft = prev.offsetLeft;
            if (prevLeft < scrollerLeft + buffer) {
              scroller.scrollBy({
                left: -(thumbWidth + buffer),
                behavior: "smooth",
              });
            }
          }
        } else {
          const thumbHeight = thumb.offsetHeight;
          const buffer = 6; // match CSS gap
          const scrollerTop = scroller.scrollTop;
          const scrollerBottom = scrollerTop + scroller.clientHeight;

          if (next) {
            const nextTop = next.offsetTop;
            if (nextTop >= scrollerBottom - buffer) {
              scroller.scrollBy({
                top: thumbHeight + buffer,
                behavior: "smooth",
              });
              return;
            }
          }

          if (prev) {
            const prevTop = prev.offsetTop;
            if (prevTop < scrollerTop + buffer) {
              scroller.scrollBy({
                top: -(thumbHeight + buffer),
                behavior: "smooth",
              });
            }
          }
        }
      });
    });
  }

  // Initialize the function
  modalThumbnailsScroll();

  // Function to reset zoom level on selection of thumbnail within the modal
  function resetZoomLevel() {
    const modalZoomed = document.querySelector(".modal-zoomed");

    if (!modalZoomed || !modalZoomed.classList.contains("modal-zoom-toggle")) {
      return false;
    }

    modalZoomed.classList.remove("gallery-mega-zoom");
  }

  // Zoom toggle function remove
  function removeZoomLevel() {
    const zoomedElement = document.querySelector(".modal-zoom-toggle");
    if (
      zoomedElement &&
      zoomedElement.classList.contains("gallery-mega-zoom")
    ) {
      zoomedElement.classList.remove("gallery-mega-zoom");
    }
  }

  function changeModalSlide(thumb, index) {
    showSlides(index);
    setActiveThumbnail(slideIndex);
    syncGalleryThumbnail(slideIndex);

    pauseGalleryMedia();
    resetZoomLevel();
    setImageToTop();
  }

  function toggleZoom(event) {
    const parentModal = event.target.closest(".modal-zoom-toggle");
    if (parentModal) {
      parentModal.classList.toggle("gallery-mega-zoom");
    }
  }

  function addZoomOnHover(event) {
    if (!isHoverCapable) return;
    const container = event.currentTarget;
    container.classList.add("hover-zoom-active");
  }

  function removeZoomOnHover(event) {
    if (!isHoverCapable) return;
    const container = event.currentTarget;
    const media = container.querySelector("img");

    container.classList.remove("hover-zoom-active");

    if (media) {
      media.style.transformOrigin = "";
    }

    if (container._hoverRaf) {
      cancelAnimationFrame(container._hoverRaf);
      container._hoverRaf = null;
    }
  }

  function handleHoverMove(event) {
    if (!isHoverCapable) return;
    const container = event.currentTarget;
    const media = container.querySelector("img");

    if (!media) {
      return;
    }

    if (container._hoverRaf) {
      cancelAnimationFrame(container._hoverRaf);
    }

    container._hoverRaf = requestAnimationFrame(() => {
      const rect = container.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;

      media.style.transformOrigin = `${x}% ${y}%`;
      container._hoverRaf = null;
    });
  }

  // Zoom toggle function
  function setModalZoomToggle() {
    if (!isHoverCapable) {
      return;
    }

    const productMediaImages = document.querySelectorAll(
      ".modal-zoom-toggle .modal-content .product-media--image"
    );

    productMediaImages.forEach((image) => {
      image.removeEventListener("click", toggleZoom);
      image.removeEventListener("mouseenter", addZoomOnHover);
      image.removeEventListener("mouseleave", removeZoomOnHover);
      image.removeEventListener("mousemove", handleHoverMove);
      image.addEventListener("mouseenter", addZoomOnHover);
      image.addEventListener("mouseleave", removeZoomOnHover);
      image.addEventListener("mousemove", handleHoverMove);
    });
  }

  // Reset image position to top on thumbnail select
  function setImageToTop(event) {
    const parentModal = document.querySelector(".modal-zoom-no-toggle");
    if (parentModal) {
      const modalContent = parentModal.querySelector(".modal-content");
      if (modalContent) {
        modalContent.scrollTop = 0; // Sets the scroll position of modal-content to the top
      }
    }
  }
}
